import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const VerifiedGradientIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 24 24",
    },
    <path
      fill="url(#verified-gradient_svg__a)"
      fillRule="evenodd"
      d="M12.718.49a1 1 0 0 0-1.436 0l-2.1 2.165-2.936-.686a1 1 0 0 0-1.208.776l-.596 2.957-2.84 1.01a1 1 0 0 0-.597 1.306l1.097 2.809-1.844 2.386a1 1 0 0 0 .204 1.421l2.442 1.77-.262 3.005a1 1 0 0 0 .94 1.085l3.012.169 1.404 2.668a1 1 0 0 0 1.378.405L12 22.25l2.624 1.486a1 1 0 0 0 1.378-.405l1.404-2.668 3.011-.17a1 1 0 0 0 .94-1.084l-.26-3.005 2.44-1.77a1 1 0 0 0 .205-1.42l-1.844-2.387 1.097-2.81a1 1 0 0 0-.596-1.305l-2.841-1.01-.596-2.957a1 1 0 0 0-1.208-.776l-2.937.686zm4.812 9.04-1.06-1.06L11 13.94l-2.47-2.47-1.06 1.06L11 16.06z"
      clipRule="evenodd"
    />,
    <defs>
      <linearGradient
        id="verified-gradient_svg__a"
        x1={26.831}
        x2={-4.273}
        y1={-0.127}
        y2={0.371}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53C1DE" />
        <stop offset={1} stopColor="#D2D943" />
      </linearGradient>
    </defs>
  );
